module.exports = __webpack_public_path__ + "img/116.40d9b511.jpg";